import { Circle, Spinner } from "tamagui";

export const LoadingCircular = ({ size = 24 }: { size?: number }) => {
  return (
    <Circle size={size} backgroundColor={"black"}>
      <Spinner size={"small"} color="$primary" />
    </Circle>
  );
};
